import { Spinner } from 'react-bootstrap';

const PriceEstimate = ({ priceEstimate, estimateError, isEstimating }) => {
  return (
    <>
      {' '}
      {isEstimating && (
        <div className="text-center mb-2">
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          &nbsp;Estimating price...
        </div>
      )}
      {estimateError && (
        <div className="alert alert-danger">{estimateError}</div>
      )}
      {priceEstimate && (
        <div className="mt-2">
          <div className="table-responsive mb-4">
            <table className="table table-sm table-striped text-center mb-0">
              <tbody>
                <tr>
                  <td>Pickup Fee (Delivery Cost)</td>
                  <td>${priceEstimate.delivery_cost}</td>
                </tr>
                <tr>
                  <td>
                    Cargo Protection Pkg (
                    {priceEstimate.cargo_insurance.insurance_range})
                  </td>
                  <td>${priceEstimate.insurance_cost}</td>
                </tr>
                <tr>
                  <td>Cost (Pickup Fee + Cargo Protection Pkg)</td>
                  <td>
                    <b>${priceEstimate.total_cost}</b>
                  </td>
                </tr>
                <tr>
                  <td>GST {parseFloat(priceEstimate.tax_rate?.gst || 0)}%</td>
                  <td>${priceEstimate.gst_five_percent}</td>
                </tr>
                <tr>
                  <td>PST {parseFloat(priceEstimate.tax_rate?.pst || 0)}%</td>
                  <td>${priceEstimate.pst_seven_percent}</td>
                </tr>
                <tr>
                  <td>HST {parseFloat(priceEstimate.tax_rate?.hst || 0)}%</td>
                  <td>${priceEstimate.hst_amount}</td>
                </tr>
                <tr>
                  <td>QST {parseFloat(priceEstimate.tax_rate?.qst || 0)}%</td>
                  <td>${priceEstimate.qst_amount}</td>
                </tr>
                <tr>
                  <td>Total Cost</td>
                  <td>
                    <b>${priceEstimate.grand_total}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default PriceEstimate;
